import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { lazy, Suspense, useState } from "react";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import { CookieBanner } from "./components/CookieBanner";
import { ChatBubble } from "./components/ChatBubble";

const ChatWindow = lazy(() => import("./components/ChatWindow"));

const WebDev = lazy(() => import("./pages/WebDev"));
const AIAutomation = lazy(() => import("./pages/AIAutomation"));
const AppDev = lazy(() => import("./pages/AppDev"));
const AITraining = lazy(() => import("./pages/AITraining"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));

const queryClient = new QueryClient();

const App = () => {
  const [chatOpen, setChatOpen] = useState(false);
  const [hasBeenOpened, setHasBeenOpened] = useState(false);

  const handleBubbleClick = () => {
    setChatOpen(true);
    if (!hasBeenOpened) setHasBeenOpened(true);
  };

  return (
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <TooltipProvider>
          <BrowserRouter>
            <Suspense fallback={<div className="min-h-screen" />}>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/tvorba-webu" element={<WebDev />} />
                <Route path="/ai-automatizace" element={<AIAutomation />} />
                <Route path="/tvorba-aplikaci" element={<AppDev />} />
                <Route path="/ai-skoleni" element={<AITraining />} />
                <Route path="/zasady-ochrany-osobnich-udaju" element={<PrivacyPolicy />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
            <CookieBanner />
            <ChatBubble onClick={handleBubbleClick} isOpen={chatOpen} hasBeenOpened={hasBeenOpened} />
            {hasBeenOpened && (
              <Suspense fallback={null}>
                <ChatWindow isOpen={chatOpen} onClose={() => setChatOpen(false)} />
              </Suspense>
            )}
          </BrowserRouter>
        </TooltipProvider>
      </LanguageProvider>
    </QueryClientProvider>
  );
};

export default App;
